import { ReactComponent as IconArrowDown } from '@/assets/svgs/chevron-down-small.svg';
import { ReactComponent as TradeTrust } from "@/assets/svgs/trade-trust.svg";
import AttachmentCard from '@/components/AttachmentCard/index.js';
import CheckboxButton from '@/components/CheckboxButton';
import { useParams } from '@/lib/router-dom/index.js';
import apiPackage from "@/services/api/packages.js";
import moment from 'moment';
import PropTypes from 'prop-types';
import DataElementVerificationInfo from "./data-element-verification-info.jsx";
import EFormRenderer from "@/components/EFormV2/EFormRenderer";
import useEForm from "@/hooks/use-eform/index";
import { useEffect, useState } from "react";
import { feature } from "@/utils/feature-verifier";
import { featureConstant } from "@/constants/configuration/feature";
import VerificationDetails, { VerificationStatus } from "@/componentsDS/VerificationDetails/VerificationDetails";
import StatusTags, { STATUS } from '@/componentsDS/Tags/StatusTags';

const DataRowContent = ({
	dataElementPayload,
	handleSelectPayload,
	selectedPayload,
	reload,
	isExpand,
	handleExpandRow
}) => {

	const verificationStatusType = {
		notApplicable: "NOT APPLICABLE",
		verified: "VERIFIED",
		unverified: "UNVERIFIED"
	}
	const { eclipId, dataElementId } = useParams();

	const {
		extractCombinedSchema,
		getSchemaWithoutAttachment
	} = useEForm();

	const [schema, setSchema] = useState(null);
	useEffect(() => {
		const elementSchema = dataElementPayload?.elementSchema
		const payload = dataElementPayload?.savedPayload

		const plainSchema = extractCombinedSchema(
			elementSchema,
			payload
		);


		const schemaWithoutAttachment = getSchemaWithoutAttachment(plainSchema);
		setSchema(schemaWithoutAttachment);
	}, []);


	async function handleExpand() {
		handleExpandRow(dataElementPayload?.messageStoreId)

		if(!dataElementPayload?.isNew) {
			return
		}

		await apiPackage.updateIsNew(eclipId, dataElementId, {
			type: dataElementPayload.type,
			parent_node_id: dataElementPayload.parent_node_id,
			parent_node_type: dataElementPayload.parent_node_type,
			eclipDataElementId: dataElementPayload.eclipDataElementId,
		});

		reload()
	}

	return (
		<>
			<div className="data-element-payload-table__data-row">
				<div className="data-element-payload-data-row__checkbox">
					<CheckboxButton
						check={selectedPayload?.findIndex((selection) => selection === dataElementPayload?.messageStoreId) !== -1}
						submit={() => handleSelectPayload(dataElementPayload?.messageStoreId)}
						value={dataElementPayload?.messageStoreId}
						disabled={dataElementPayload.hasExpired}
					/>
				</div>
				<div className="data-element-payload-data-row__serial-number">
					<div className="data-element-payload-data-row__serial-number-text">{dataElementPayload.serialNumber}</div>
					{dataElementPayload.isNew && <div className="package-received-data-card__new-tag" data-testid="new-tag">New</div>}
					{dataElementPayload.hasExpired && <StatusTags status={STATUS.EXPIRED} />}
				</div>
				<div className="data-element-payload-data-row__verification">
					{!(dataElementPayload.isTTFlow || (!dataElementPayload.isTTFlow && dataElementPayload.verificationStatus !== verificationStatusType.notApplicable)) && (
						<div>---</div>
					)}
					{(dataElementPayload.isTTFlow || (!dataElementPayload.isTTFlow && dataElementPayload.verificationStatus !== verificationStatusType.notApplicable)) && (
						<div className="verification__TT-icon tooltip">
							<TradeTrust />
							<span className="tooltiptext">TradeTrust Enabled</span>
						</div>
					)}

					{dataElementPayload.verificationStatus !== verificationStatusType.notApplicable && (
						<div className="verification__verified-status" data-testid="tt-verified-status">
							{dataElementPayload.verificationStatus === verificationStatusType.verified && "Verified"}
							{dataElementPayload.verificationStatus === verificationStatusType.unverified && "Unverified"}
						</div>
					)}
				</div>
				<div className="data-element-payload-data-row__created-date">
					<div>{moment(dataElementPayload.created).format('DD/MM/YYYY')}</div>
					<div>{moment(dataElementPayload.created).format('HH:mmA')}</div>
				</div>
				<div className="data-element-payload-data-row__attachment">{`${dataElementPayload?.savedPayload?.attachments?.length || 0} Attachment(s)`}</div>
				{!dataElementPayload?.hasExpired ? <div className="data-element-payload-data-row__action" data-testid="expand-arrow" onClick={handleExpand} onKeyDown={handleExpand} >
					<div className="data-row-action__arrow" style={
						{
							transform: isExpand ? 'rotate(180deg)' : 'rotate(0deg)',
							transition: 'transform 0.2s ease-in-out'
						}
					}><IconArrowDown /></div>
				</div> : <div className="data-element-payload-data-row__action"></div>}
			</div>
			{isExpand && (
				<div className="data-element-payload-data-row__details" data-testid="payload-details">
					<div className="data-element-payload-data-row__eform">
							<EFormRenderer
								payload={dataElementPayload?.savedPayload}
								schema={schema}
								isReadOnly={true}
							/>
					</div>
					<div className="data-element-payload-data-row__other-info">
						{dataElementPayload?.savedPayload?.attachments?.length > 0 && (
							<div className="data-element-payload-other-info__attachment">
								<AttachmentCard
									attachmentList={dataElementPayload?.savedPayload?.attachments}
								/>
							</div>
						)}
						<div className="data-element-payload-other-info__Verification">
							{dataElementPayload.verificationStatus !== verificationStatusType.notApplicable && (
								<VerificationDetails
									status={dataElementPayload.verificationStatus === verificationStatusType.verified ? VerificationStatus.SUCCESS : VerificationStatus.FAILURE}
									issuer={dataElementPayload?.issuerDetail?.[0]?.name}
									learnMore={ () => {
										window.open('https://docs.tradetrust.io/docs/introduction/what-is-tradetrust', '_blank','noopener,noreferrer');
									}}
								/>
							)}
						</div>
					</div>
				</div>
			)}
		</>
	)
}

DataRowContent.propTypes = {
	dataElementPayload: PropTypes.shape({
		messageStoreId: PropTypes.any,
		isTTFlow: PropTypes.bool,
		isNew: PropTypes.bool,
		hasExpired: PropTypes.bool,
		verificationStatus: PropTypes.string,
		created: PropTypes.any,
		savedPayload: PropTypes.shape({
			attachments: PropTypes.any
		}),
		elementName: PropTypes.string,
		serialNumber: PropTypes.number,
		elementSchema: PropTypes.object,
		parent_node_id: PropTypes.string,
		parent_node_type: PropTypes.string,
		eclipDataElementId: PropTypes.string,
		issuerDetail: PropTypes.arrayOf(
			PropTypes.shape({
				name: PropTypes.string,
			})
		),
	}),
	handleSelectPayload: PropTypes.any,
	selectedPayload: PropTypes.array,
	reload: PropTypes.func,
	isExpand: PropTypes.any,
	handleExpandRow: PropTypes.func
};

export default DataRowContent;
